<template>
<div class="patrolReport">
  <el-dialog title="巡查单查看" :visible.sync="dialogVisible" v-on:close="closeReport">
    <!-- <el-table :data="dataOne"
                border
                style="width: 100%">
        <el-table-column prop="name" label="巡检计划名称">
        </el-table-column>
        <el-table-column prop="" label="巡检时间">
          <template slot-scope="scope">
            <div>{{scope.row.enddate==null?timefilters(scope.row.begindate)+"至今":timefilters(scope.row.begindate)+"至"+timefilters(scope.row.enddate)}}</div>
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="dataOne"
                border
                style="width: 100%">
        <el-table-column prop="username" label="巡检员">
        </el-table-column>
        <el-table-column label="巡检单状态">
          <template slot-scope="scope">
            <div>{{scope.row.status==1 ? '进行中' : '已结束'}}</div>
          </template>
        </el-table-column>
      </el-table> -->
    <el-table :data="gridData" border style="width: 100%">
      <el-table-column prop="templateName" label="巡检模板" width="150px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="pointName" label="巡检点" width="150px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="typeName" label="巡检设备类型" width="150px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="content" label="巡检内容" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="depict" label="描述" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="imgDepict" label="图片" show-overflow-tooltip>
        <template slot-scope="scope">
          <div style="display: flex;">
            <div v-for="(urlData, index) in scope.row.imgDepict" :key="index" style="margin-right: 10px;" @click="handleBigImage(urlData)">
              <img style="width: 30px; height: 30px;" :src="`${baseUrlAddr}/front/polling/img/download?fileName=${urlData}`" alt="">
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="巡检状态" width="80px">
        <template slot-scope="scope">
          <div>{{ scope.row.status == '0' ? '正常' : '异常' }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="recordinfo" label="处理意见">
      </el-table-column> -->
    </el-table>
    <!-- <el-table
              :data="dataOne"
              border
              style="width: 100%">
        <el-table-column
                prop="sign"
                label="签名">
          <template slot-scope="scope">
            <img :class="['imgShow',[scope.row.rotate==1?'active':'']]" :src="scope.row.sign">
          </template>
        </el-table-column>
      </el-table> -->
  </el-dialog>
  <div class="certificateImg">
    <el-dialog
      title="巡检图片"
      :visible.sync="dialogVisibles"
      width="30%"
     >
     <div>
        <img :src="`${baseUrlAddr}/front/polling/img/download?fileName=${bigUrl}`" alt="">
     </div>
    </el-dialog>
  </div>
</div>
</template>

<script>
export default {
  props: {
    propRow: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      dataOne: [],
      gridData: [],
      dialogVisible: false,
      dialogVisibles: false,
      bigUrl: '',
    }
  },
  created() {
    //巡查报表
    this.initReport();
  },
  methods: {
    //巡查报表初始化
    initReport() {
      console.log((this.propRow))
      this.dataOne = [];
      this.dataOne.push(this.propRow);
      this.dialogVisible = true;
      this.request.get("/front/polling/record/detail/recordDetailPageList?recordId=" + this.propRow.recordId).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.gridData = res.data;
          this.gridData.forEach(data => {
            let imgDepict = data.imgDepict.split(';').filter(item => item != '')
            data.imgDepict = imgDepict
          })
        } else if (res.code == 500) {
          this.msg.warn(res.msg);
        }
      }).catch(error => {
        console.log(error);
      })
    },
    //关闭
    closeReport() {
      this.$emit('closeReport', false);
    },
    //转换时间
    timefilters(val) {
      if (val == null || val == "") {
        return "暂无时间";
      } else {
        let d = new Date(val); //val 为表格内取到的后台时间
        let month =
          d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times = d.getFullYear() + "-" + month + "-" + day + " " + hours + ':' + min + ':' + sec;
        return times;
      }
    },
    // 点击图片 放大
    handleBigImage (url) {
      this.dialogVisibles = true
      this.bigUrl = url
    },
    handleGetUrl (url) {
       this.request.get(`/front/polling/img/download?fileName=84d95a5f-63fc-49c6-ba91-9fd62f3d11a7.jpg`).then(res => {
        console.log(8888, res)
       })
    },
  }
}
</script>

<style lang="scss" scoped>
.patrolReport {
  .imgShow {
    &.active {
      transform: rotate(180deg);
    }
  }
  .certificateImg {
    ::v-deep .el-dialog {
      width: 30%;
      .el-dialog__body {
        >div {
          width: 100%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style><style lang="scss">
.patrolReport {
  .el-dialog__wrapper {
    height: 100%;
    overflow: hidden;

    .el-dialog {
      height: 80%;
      overflow: hidden;

      .el-dialog__body {
        height: 100%;
        box-sizing: border-box;
        overflow-y: scroll;
        padding-bottom: 70px !important;
        .el-table th>.cell{
          font-weight:600;
          color:#606266;
        }
      }
    }
  }
}
</style>
